import { render, staticRenderFns } from "./BillAPList.vue?vue&type=template&id=06a82ebe"
import script from "./BillAPList.vue?vue&type=script&lang=js"
export * from "./BillAPList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports